import { render, staticRenderFns } from "./PriAlumnoCabecera.vue?vue&type=template&id=15f0a5fd&scoped=true&"
import script from "./PriAlumnoCabecera.vue?vue&type=script&lang=js&"
export * from "./PriAlumnoCabecera.vue?vue&type=script&lang=js&"
import style0 from "./PriAlumnoCabecera.vue?vue&type=style&index=0&id=15f0a5fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0a5fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardText,VCardTitle,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle})
